<template>
  <div data-testid="dropdown" v-if="width !== ''" class="" style="background: white;">
    <v-combobox
      data-testid="dropdown__combobox"
      v-if="customvalue"
      ref="element"
      style="background: white;"
      outlined
      dense
      :style="`width:${width}`"
      :label="label ?? ''"
      :clearable="clearable"
      :error-messages="error"
      v-model="content"
      :search-input.sync="searchInput"
      @click:clear="content = ''"
      @change="updateValue()"
      :items="items"
      :chips="chips"
      :deletable-chips="chips"
      :hide-details="hidedetails"
      :disabled="disabled"
      :item-text="itemtext"
      :item-value="itemvalue"
      :readonly="readonly"
      :multiple="multiple"
      :prepend-inner-icon="prependinnericon"
      :append-icon="appendicon"
      :prefix="prefix"
      :suffix="suffix"
      :class="`${transformClass} ${roundedClass}`"
      :menu-props="menuProps"
    >
      <template v-if="itemClass" v-slot:item="data">
        <span data-testid="dropdown__combobox-item" :class="itemClass">
          <template v-if="isInactive(data.item)">
            {{ (typeof data.item === 'object' ? data.item[itemtext] : data.item).replace(' (Inactive)', '') }}
            <span data-testid="dropdown__combobox-item-inactive" class="error--text"> (Inactive)</span>
          </template>
          <template v-else>
            {{ typeof data.item === 'object' ? data.item[itemtext] : data.item }}
          </template>
        </span>
      </template>
    </v-combobox>
    <v-autocomplete
      data-testid="dropdown__autocomplete"
      ref="element"
      outlined
      dense
      :style="`width:${width}`"
      :label="label ?? ''"
      :clearable="clearable"
      :error-messages="error"
      v-model="content"
      :search-input.sync="searchInput"
      @click:clear="content = ''"
      @change="updateValue()"
      :items="items"
      :chips="chips"
      :deletable-chips="chips"
      :hide-details="hidedetails"
      :disabled="disabled"
      :item-text="itemtext"
      :item-value="itemvalue"
      :readonly="readonly"
      :multiple="multiple"
      :prepend-inner-icon="prependinnericon"
      :append-icon="appendicon"
      :prefix="prefix"
      :suffix="suffix"
      :placeholder="placeholder"
      :class="`${transformClass} ${roundedClass}`"
      :menu-props="menuProps"
      class="autocomplete-dropdown"
    >
      <template v-if="itemClass" v-slot:item="data">
        <span data-testid="dropdown__autocomplete-item" :class="itemClass">
          <template v-if="isInactive(data.item)">
            {{ (typeof data.item === 'object' ? data.item[itemtext] : data.item).replace(' (Inactive)', '') }}
            <span data-testid="dropdown__autocomplete-item-inactive" class="error--text"> (Inactive)</span>
          </template>
          <template v-else>
            {{ typeof data.item === 'object' ? data.item[itemtext] : data.item }}
          </template>
        </span>
      </template>
    </v-autocomplete>
  </div>
  <v-combobox
    data-testid="dropdown__combobox"
    ref="element"
    outlined
    dense
    style="background: white;"
    v-else-if="customvalue"
    :label="label ?? ''"
    :clearable="clearable"
    :error-messages="error"
    v-model="content"
    :search-input.sync="searchInput"
    @click:clear="content = ''"
    @change="updateValue()"
    :items="items"
    :chips="chips"
    :deletable-chips="chips"
    :hide-details="hidedetails"
    :disabled="disabled"
    :item-text="itemtext"
    :item-value="itemvalue"
    :readonly="readonly"
    :multiple="multiple"
    :prepend-inner-icon="prependinnericon"
    :append-icon="appendicon"
    :prefix="prefix"
    :suffix="suffix"
    :class="`${transformClass} ${roundedClass}`"
    :menu-props="menuProps"
  >
    <template v-if="itemClass" v-slot:item="data">
        <span data-testid="dropdown__combobox-item" :class="itemClass">
          <template v-if="isInactive(data.item)">
            {{ (typeof data.item === 'object' ? data.item[itemtext] : data.item).replace(' (Inactive)', '') }}
            <span data-testid="dropdown__combobox-item-inactive" class="error--text"> (Inactive)</span>
          </template>
          <template v-else>
            {{ typeof data.item === 'object' ? data.item[itemtext] : data.item }}
          </template>
        </span>
      </template>
  </v-combobox>
  <v-autocomplete
    data-testid="dropdown__autocomplete"
    ref="element"
    outlined
    dense
    v-else
    :label="label ?? ''"
    :clearable="clearable"
    :error-messages="error"
    v-model="content"
    :search-input.sync="searchInput"
    @click:clear="content = ''"
    @change="updateValue()"
    :items="items"
    :chips="chips"
    :deletable-chips="chips"
    :hide-details="hidedetails"
    :disabled="disabled"
    :item-text="itemtext"
    :item-value="itemvalue"
    :readonly="readonly"
    :multiple="multiple"
    :prepend-inner-icon="prependinnericon"
    :append-icon="appendicon"
    :prefix="prefix"
    :suffix="suffix"
    :placeholder="placeholder"
    :class="`${transformClass} ${roundedClass}`"
    :menu-props="menuProps"
    class="autocomplete-dropdown"
  >
    <template v-if="itemClass" v-slot:item="data">
        <span data-testid="dropdown__autocomplete-item" :class="itemClass">
          <template v-if="isInactive(data.item)">
            {{ (typeof data.item === 'object' ? data.item[itemtext] : data.item).replace(' (Inactive)', '') }}
            <span data-testid="dropdown__autocomplete-item-inactive" class="error--text"> (Inactive)</span>
          </template>
          <template v-else>
            {{ typeof data.item === 'object' ? data.item[itemtext] : data.item }}
          </template>
        </span>
      </template>
  </v-autocomplete>
</template>

<script>
export default {
  activated() {
    this.setValue();
    this.updateValue();
  },
  created() {
    this.setValue();
    this.updateValue();
  },
  data: () => ({
    content: "",
    tempContent: "",
    searchInput: "",
  }),
  props: {
    error: {
      type: [String, Array],
    },
    label: {
      type: String,
    },
    value: {
      type: [String, Array, Number],
      default: function () {
        return [];
      },
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    width: {
      type: String,
      default: "",
    },
    itemtext: {
      type: String,
      default: "name",
    },
    itemvalue: {
      type: String,
      default: "value",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    customvalue: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hidedetails: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    prependinnericon: {
      type: String,
      default: "",
    },
    appendicon: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder:{
      type:String,
      default:''
    },
    itemClass: {
      type: String,
      default: ''
    },
    roundedClass: {
      type: String,
      default: "",
    },
    transformClass: {
      type: String,
      default: "noTransform",
    }
    // required: {
    //   type: Boolean,
    //   default: false
    // }
  },
  methods: {
    setValue: function () {
      this.content = this.value;
    },
    updateValue: function () {
      if (this.multiple) {
        this.searchInput = "";
      }
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    setFocus: function () {
      this.$nextTick(() => {
        this.$refs.element.$el.querySelector("input").focus();
      });
    },
    isInactive: function (item) {
      const text = typeof item === 'object' ? (item[this.itemtext] || '') : (item || '');
      return text.toString().includes('(Inactive)');
    },
    normalizeComparableValue: function (value) {
      if (value === undefined || value === null) return "";
      return String(value);
    },
  },
  computed: {
    menuProps() {
      return { contentClass: this.itemClass ? `${this.itemClass} lb-dropdown-menu` : 'lb-dropdown-menu' };
    },
  },
  watch: {
    value: function () {
      this.$nextTick(() => {
        this.setValue();
      });
    },
    items: function (newItems) {
      let hasitem = false;
      const isMultipleValue = this.multiple || Array.isArray(this.content);
      const selectedValues = isMultipleValue
        ? (Array.isArray(this.content) ? this.content : [])
            .map((value) => this.normalizeComparableValue(value))
            .filter((value) => value !== "")
        : [this.normalizeComparableValue(this.content)].filter((value) => value !== "");

      if (newItems.length > 0) {
        if (
          typeof newItems[0] === "object" &&
          !(newItems[0] instanceof Array)
        ) {
          const itemValues = newItems.map((item) =>
            this.normalizeComparableValue(item[this.itemvalue])
          );
          hasitem = isMultipleValue
            ? selectedValues.every((value) => itemValues.includes(value))
            : itemValues.includes(this.normalizeComparableValue(this.content));
        } else {
          const itemValues = newItems.map((item) => this.normalizeComparableValue(item));
          hasitem = isMultipleValue
            ? selectedValues.every((value) => itemValues.includes(value))
            : itemValues.includes(this.normalizeComparableValue(this.content));
        }
      }
      if (!hasitem) this.content = isMultipleValue ? [] : "";
      if (!isMultipleValue && newItems.length === 1 && (this.content || "").toString() === "") {
        if (newItems[0] instanceof Array)
          this.content = (newItems[0] || this.content || "").toString();
        else if (typeof newItems[0] === "object")
          this.content = (newItems[0][this.itemvalue] || "").toString();
        this.updateValue();
      }
    },
  },
};
</script>

<style>
.lb-dropdown-menu {
  border-radius: var(--radius-8) !important;
  margin-left: 0 !important;
}
</style>